import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children, allowedRoles }) {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const userRole = (currentUser.role || '').toLowerCase();
    if (!allowedRoles.map(r => r.toLowerCase()).includes(userRole)) {
      return <Navigate to="/unauthorized" />;
    }
  }

  return children;
}

export default ProtectedRoute;
